'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("App");

var initialState = {
    processing: false,
    items: {}
};

function numbersOnly(value) {
    if (typeof value !== 'string') value = '';
    return value.replace(/\D/g, '');
}

function getNumber(value) {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string') value = null;
    value = parseInt(value, 10);
    if (isNaN(value)) {
        value = null;
    }
    return value;
}

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var newState = state;
    switch (action.type) {

        case _actionTypes2.default.UPDATE:
            var _action$item = action.item,
                id = _action$item.id,
                complaintAmount = _action$item.complaintAmount,
                amount = _action$item.amount,
                complainedAmount = _action$item.complainedAmount,
                ean = _action$item.ean,
                productName = _action$item.productName,
                alreadyComplainedAmount = _action$item.alreadyComplainedAmount;

            if (!state.processing) {
                newState = (0, _merge2.default)({}, state);
                if (!complaintAmount) {
                    delete newState.items[id];
                } else if (complaintAmount <= 0) {
                    delete newState.items[id];
                    _notify2.default.error(resx.App.EnterValidNumberFromOneTo + ' ' + amount);
                } else if (amount < complaintAmount + alreadyComplainedAmount) {
                    newState.items[id] = { id: id, ean: ean, amount: amount - alreadyComplainedAmount, productName: productName };
                    _notify2.default.error(resx.App.YouCanComplaintMaximumWhatYouBought);
                } else {
                    newState.items[id] = { id: id, ean: ean, amount: complaintAmount, productName: productName };
                }
            }
            var item = newState.items[id];
            var inputValue = !!item ? item.amount + '' : '';
            action.input.val(inputValue);
            break;

        case _actionTypes2.default.SUBMIT:
            newState = (0, _assign2.default)({}, state, { processing: true });
            break;

        case _actionTypes2.default.SUBMITTED:
            newState = (0, _assign2.default)({}, initialState);
            break;

        case _actionTypes2.default.CANCELLED:
            newState = (0, _assign2.default)({}, initialState);
            break;

        case _actionTypes2.default.SUBMIT_FAILED:
            newState = (0, _assign2.default)({}, state, { processing: false });
            break;
    }
    return newState;
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/complaints/reducer.js
// module id = 422
// module chunks = 0